/* eslint-disable max-classes-per-file */
import React, { Component } from 'react'
import {
  ItemIdentifier,
  ProductionOrder,
  ProductionOrderRow,
  IdentifierReel,
  IdentifierEvent,
  ProductionOrderRows,
  IdentifierReels,
  IdentifierEvents
} from 'stylewhere/api'
import { Spinner } from '@chakra-ui/react'
import { Box, Card, Modal, ModalTitle, IdentifierEventBox, ProductInfoBox } from 'stylewhere/components'
import { T, __ } from 'stylewhere/i18n'

interface Props {
  onClose: () => void
  identifier: ItemIdentifier
  visible: boolean
}

interface State {
  identifierEvents?: IdentifierEvent[]
  identifierReel?: IdentifierReel
  identifierReelLoading: boolean
  productionOrder?: ProductionOrder
  productionOrderRow?: ProductionOrderRow
  productionOrderLoading: boolean
}

export class IdentifierInfoModal extends Component<Props, State> {
  state: State = {
    identifierEvents: undefined,
    identifierReel: undefined,
    identifierReelLoading: false,
    productionOrder: undefined,
    productionOrderRow: undefined,
    productionOrderLoading: false
  }

  async componentDidMount() {
    this.init()
  }

  init = async () => {
    this.fetchIdentifierEvents()
    this.fetchProductionOrder()
    this.fetchReelInfo()
  }

  fetchIdentifierEvents = async () => {
    const { identifier } = this.props

    if (identifier?.id) {
      try {
        const resEvents = await IdentifierEvents.getIdentifierEvents(identifier.id)
        this.setState({
          identifierEvents: resEvents.content
        })
      } catch (error) {
        this.setState({
          identifierEvents: []
        })
      }
    } else
      this.setState({
        identifierEvents: []
      })
  }

  fetchProductionOrder = async () => {
    const { identifier } = this.props
    this.setState({ productionOrderLoading: true })

    if (identifier?.productionOrderRowId) {
      try {
        const res = (await ProductionOrderRows.get(identifier.productionOrderRowId)) as ProductionOrderRow
        this.setState({
          productionOrderRow: res,
          productionOrder: res.productionOrder,
          productionOrderLoading: false
        })
      } catch (error) {
        console.log(error)
        this.setState({
          productionOrder: undefined,
          productionOrderRow: undefined,
          productionOrderLoading: false
        })
      }
    } else {
      this.setState({
        productionOrder: undefined,
        productionOrderRow: undefined,
        productionOrderLoading: false
      })
    }
  }

  fetchReelInfo = async () => {
    const { identifier } = this.props
    this.setState({ identifierReelLoading: true })

    if (identifier?.reelId) {
      try {
        const res = (await IdentifierReels.get(identifier.reelId)) as IdentifierReel
        this.setState({
          identifierReel: res,
          identifierReelLoading: false
        })
      } catch (error) {
        console.log(error)
        this.setState({
          identifierReel: undefined,
          identifierReelLoading: false
        })
      }
    } else {
      this.setState({
        identifierReel: undefined,
        identifierReelLoading: false
      })
    }
  }

  render() {
    const { visible, onClose, identifier } = this.props
    const { productionOrder, productionOrderRow, identifierReel, identifierEvents, identifierReelLoading } = this.state

    return (
      <Modal size="6xl" onClose={onClose} visible={visible} fullContent showCloseButton>
        <Box flex row>
          <Box flex={3} ml={35} style={{ minWidth: 0 }}>
            <ModalTitle
              title={__(T.misc.identifier_info)}
              data-testid={`identifiers-modal-title`}
              style={{ flex: 0, paddingTop: 20, paddingBottom: 15 }}
            />
            <Box
              flex
              ph={35}
              pb={0}
              pr={0}
              pl={0}
              mr={35}
              mb={20}
              style={{
                height: 'calc(80vh - 40px)',
                maxHeight: 'calc(80vh - 40px)',
                overflow: 'auto',
                overflowX: 'hidden',
                zIndex: 1001
              }}
            >
              {identifier && (
                <>
                  <Card mb={10} flex title={__(T.misc.identifier_info)}>
                    <ProductInfoBox.Field label={__(T.misc.code)} value={identifier.code} />
                    <ProductInfoBox.Field
                      label={__(T.misc.type)}
                      value={identifier.type ? identifier.type.replaceAll('_', ' ').toUpperCase() : ''}
                    />
                    <ProductInfoBox.Field
                      label={__(T.misc.status)}
                      value={identifier.status ? identifier.status.replaceAll('_', ' ').toUpperCase() : ''}
                    />
                  </Card>

                  <Card mb={10} flex title={__(T.misc.production_order_info)}>
                    <ProductInfoBox.Field label={__(T.misc.production_order)} value={productionOrder?.code} />
                    <ProductInfoBox.Field label={__(T.misc.production_order_row)} value={productionOrderRow?.code} />
                  </Card>
                  <Card mb={10} flex title={__(T.misc.reel_info)}>
                    {identifierReelLoading && (
                      <Box mt={20} center>
                        <Spinner color="#000" size="md" />
                      </Box>
                    )}
                    {!identifierReelLoading && (
                      <>
                        <ProductInfoBox.Field label={__(T.misc.reel_code)} value={identifierReel?.code ?? '---'} />
                        <ProductInfoBox.Field
                          label={__(T.misc.assigned_supplier)}
                          value={identifierReel?.place?.description}
                        />
                        <ProductInfoBox.Field
                          label={__(T.misc.only_quantity)}
                          value={String(identifierReel?.quantity ?? '---')}
                        />
                      </>
                    )}
                  </Card>
                </>
              )}
            </Box>
          </Box>
          <IdentifierEventBox events={identifierEvents} />
        </Box>
      </Modal>
    )
  }
}
